// Когда показывать окно техработ. Чистые функции, чтобы проверить их тестами
// (maintenanceState.test.js), а MaintenanceWatcher.jsx только опрашивает сервер.
//
// Раньше окно открывалось после первой же неудачной проверки: моргнул Wi‑Fi,
// ноутбук проснулся, сервер ответил дольше обычного. А следующая удачная проверка
// считалась концом обновления и через 3 секунды перезагружала страницу, стирая
// всё, что человек набрал.
// Теперь окно открывается, только если сервер сам сказал «идут техработы»
// или не отвечал подряд DOWN_AFTER_MS при работающем интернете. Когда всё снова
// работает, окно закрывается без перезагрузки; о новой версии кабинета говорит
// отдельная плашка (isOutdated).

// Тот же шаг опрашивает общий выключатель меню (component/navV3/ShellSwitch.jsx).
export const POLL_MS = 5000;
// После ошибки проверяем чаще, чтобы окно не опаздывало, когда сервер правда лёг.
export const RETRY_MS = 2500;
// Сколько ошибок подряд терпим, прежде чем открыть окно.
export const DOWN_AFTER_MS = 10000;
export const DOWN_AFTER_FAILS = 2;
// Ответ дольше этого считаем ошибкой, иначе зависшие запросы копятся.
export const REQUEST_TIMEOUT_MS = 8000;
// Сколько показываем «снова работает», прежде чем закрыть окно.
export const BACK_CLOSE_MS = 4000;

// ok — окна нет; maintenance — сервер включил техработы; unreachable — сервер
// не отвечает; back — снова работает, окно скоро закроется само.
export const initialWatchState = { phase: "ok", fails: 0, failingSince: null };

export const isBlocking = (phase) => phase === "maintenance" || phase === "unreachable";
export const isShown = (phase) => phase !== "ok";

export function nextWatchState(state, event, now) {
  if (event.type === "status") {
    if (event.on) return { phase: "maintenance", fails: 0, failingSince: null };
    return { phase: isBlocking(state.phase) ? "back" : state.phase, fails: 0, failingSince: null };
  }

  if (event.type === "error") {
    // Нет интернета у самого человека: это не наши техработы. Окно не открываем,
    // а открытое «Упрости недоступен» убираем: дело было в связи у человека.
    if (event.offline) {
      const phase = state.phase === "unreachable" ? "ok" : state.phase;
      return { phase, fails: 0, failingSince: null };
    }

    const fails = state.fails + 1;
    const failingSince = state.failingSince ?? now;
    const longEnough = fails >= DOWN_AFTER_FAILS && now - failingSince >= DOWN_AFTER_MS;
    const canFail = state.phase === "ok" || state.phase === "back";
    const phase = canFail && longEnough ? "unreachable" : state.phase;
    return { phase, fails, failingSince };
  }

  // Вкладка снова на экране или вернулся интернет: первые запросы после сна
  // часто падают, считаем ошибки заново.
  if (event.type === "resume") return { ...state, fails: 0, failingSince: null };

  // «Снова работает» закрыли кнопкой или по времени.
  if (event.type === "close") return state.phase === "back" ? { ...state, phase: "ok" } : state;

  return state;
}

// Имя главного файла сборки (main.<hash>.js) из адреса скрипта; без хеша (разработка) — null.
export function bundleVersion(src) {
  const match = String(src || "").match(/static\/js\/(main\.[0-9a-f]+\.js)/);
  return match ? match[1] : null;
}

// Сервер отдаёт другую сборку, чем открыта у человека, и плашку про неё не закрывали.
export function isOutdated(own, server, dismissed) {
  return Boolean(own && server && server !== own && server !== dismissed);
}
